import { STATUS, BILLING, merchantCls } from "@/lib/constants";
import { Lock } from "lucide-react";

export function StatusBadge({ status, locked, testId }) {
  const s = STATUS[status] || { label: status, cls: "bg-slate-800 text-slate-300 border-slate-700" };
  return (
    <span data-testid={testId || `status-badge-${status}`} className={`inline-flex items-center gap-1 rounded border px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide ${s.cls}`}>
      {locked && <Lock className="h-3 w-3" />}{s.label}
    </span>
  );
}

export function BillingBadge({ type }) {
  const b = BILLING[type] || { short: type, cls: "" };
  return <span className={`inline-flex rounded border px-2 py-0.5 text-[11px] font-medium ${b.cls}`}>{b.short}</span>;
}

export function MerchantBadge({ name }) {
  if (!name) return <span className="text-slate-600">—</span>;
  return <span className={`inline-flex rounded border px-2 py-0.5 text-[11px] font-medium ${merchantCls(name)}`}>{name}</span>;
}

export function Money({ value, tone = "", testId }) {
  const tones = { mco: "text-emerald-400 font-bold", cost: "text-rose-400/90", gross: "text-slate-100" };
  return <span data-testid={testId} className={`font-mono tabular-nums ${tones[tone] || tone}`}>{Number(value || 0).toLocaleString("en-US", { style: "currency", currency: "USD" })}</span>;
}

export function Kpi({ label, value, sub, accent = "", testId }) {
  return (
    <div className="panel p-5 fade-up" data-testid={testId}>
      <div className="eyebrow">{label}</div>
      <div className={`font-display text-3xl font-bold mt-2 ${accent}`}>{value}</div>
      {sub && <div className="text-xs text-slate-500 mt-1">{sub}</div>}
    </div>
  );
}

export function PageHeader({ eyebrow, title, children }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
      <div>
        {eyebrow && <div className="eyebrow mb-1">{eyebrow}</div>}
        <h1 className="font-display text-2xl sm:text-3xl font-bold">{title}</h1>
      </div>
      <div className="flex items-center gap-2">{children}</div>
    </div>
  );
}

export function Empty({ text, testId }) {
  return <div data-testid={testId} className="text-center py-12 text-sm text-slate-500">{text}</div>;
}
